<template>

    <section class="c-patient_list">
        <h3>Lista pacjentów</h3>

        <form-input
            v-model="query"
            label="Wyszukaj pacjentów"
            class="c-patient_list__searchbar"
            btn="green"
            btn-label="Szukaj"
            btn-has-loader
            :btn-loading="isFetching"
            @input="search"
            speech-to-text>
        </form-input>

        <v-table class="c-patient_list__table">
            <thead>
            <th>Imię i Nazwisko</th>
            <th>PESEL</th>
            <th>Telefon</th>
            <th>Email</th>
            <th>Przedstawiciel ustawowy</th>
            <th>Dostępne akcje</th>
            </thead>
            <tbody ref="tbody">
            <tr
                v-for="patient in value"
                :key="patient.id"
                @click="patientClick(patient.id, $event)">
                <td>{{ patientName(patient) }}</td>
                <td>{{ patient.pesel || '&mdash;' }}</td>
                <td>{{ patient.phone || '&mdash;' }}</td>
                <td>{{ patient.email || '&mdash;' }}</td>
                <td>{{ contactPersonName(patient) || '&mdash;' }}</td>
                <td class="c-patient_list__table-actions">
                    <v-btn
                        type="green"
                        size="small"
                        :to="{ name: 'PatientEventAdd', params: { id: patient.id } }">
                        Zaplanuj wizytę
                    </v-btn>

                    <v-btn
                        type="icon"
                        icon="edit"
                        title="Edytuj pacjenta"
                        :to="{ name: 'PatientEdit', params: { id: patient.id } }">
                    </v-btn>

                    <v-btn
                        type="icon"
                        icon="delete"
                        title="Usuń pacjenta"
                        @click="removePatient(patient.id)">
                    </v-btn>

                </td>
            </tr>
            </tbody>
            <p class="c-patient_list__empty" v-if="value.length === 0">Brak pacjentów</p>
            <v-loader
                :loading="isFetching"
                :bind-to="$refs.tbody">
            </v-loader>
        </v-table>
        <visit-add-modal ref="visitAddModal"></visit-add-modal>
        <patient-remove-modal ref="patientRemoveModal"></patient-remove-modal>
    </section>

</template>


<script>

import {mapGetters} from 'vuex'
import {FormInput} from 'Components/Form'
import PatientRemoveModal from 'Components/Patient/PatientRemoveModal'
import VisitAddModal from 'Components/Visit/VisitAddModal'

import VLoader from 'Components/VLoader'
import VBtn from 'Components/VBtn'
import VTable from 'Components/VTable'

export default {

    name: 'PatientList',

    props: {
        value: Array,
        isFetching: Boolean
    },

    data() {
        return {
            query: this.$route.query.query || ''
        }
    },

    methods: {
        search(q) {
            this.$router.push({name: 'Patients', query: {query: q}})
        },
        patientClick(id, e) {
            if (e.target.tagName === 'A')
                return
            this.$router.push({name: 'PatientShow', params: {id}})
        },
        removePatient(id) {
            this.$refs.patientRemoveModal.$emit('open', id)
        },
        patientName(patient) {
            return patient.first_name + ' ' + patient.last_name
        },
        contactPersonName(patient) {
            if (patient.contact_person_first_name && patient.contact_person_last_name)
                return patient.contact_person_first_name + ' ' + patient.contact_person_last_name

            return null

        }
    },

    components: {
        FormInput,
        VLoader,
        VBtn,
        VTable,
        PatientRemoveModal,
        VisitAddModal
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-patient_list {
    &__searchbar {
        max-width: 450px;
    }
    &__empty {
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 1.2rem;
        margin: 2rem 0;
        width: 100%;
        text-align: center;
    }
    &__table {
        margin-top: 50px;
        position: relative;
        min-height: 450px;

        &-actions {
            display: flex;
            width: 100%;
            justify-content: flex-end;
            flex-shrink: 0;

            span {
                margin-right: .5rem;

                &:last-child {
                    margin-right: 0;
                }
            }
        }
        tr {
            cursor: pointer;

            &:hover {
                background-color: rgba($c-border, 0.15);
            }
        }
    }
}

</style>
